function quick_add_cart(productCard, input) {

    const drawer = productCard.querySelector('quick-buy-drawer');
    const selectedColor = productCard.querySelector('.product-card__aside input:checked')?.value;
    const selectedSize = input.value;

    const colorOption = selectedColor && drawer.querySelector(`input[value="${selectedColor}"]`);
    const sizeOption = selectedSize && drawer.querySelector(`input[value="${selectedSize}"]`);

    if (selectedColor) colorOption.click();
    if (selectedSize) sizeOption.click();

    const selectedVariantId = drawer.querySelector('form input[name="id"]')?.value;
    const cart_drawer = document.querySelector('cart-drawer');
    if (selectedVariantId) {
        addToCart(selectedVariantId, 1);
        if (cart_drawer.getAttribute('open') === null) {
            const cartBtn = document.querySelector("[data-no-instant]")
            cartBtn && cartBtn.click();
            cart_drawer.setAttribute('open', '');
        }
    }
}

function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    })
        .then(response => response.json())
        .then(data => {
            console.log('Item added to cart:', data);
        })
        .catch((error) => {
            console.error('Error adding item to cart:', error);
        });
}

document.addEventListener('DOMContentLoaded', function () {
    function handleSizedClick(){
        const sizes = document.querySelectorAll('.product-card__sizes');

        sizes.forEach((size) => {
            size.querySelectorAll('input').forEach((input) => {
                input.addEventListener('click', function () {
                    const productCard = this.closest('.product-card');
                    quick_add_cart(productCard, this);
                });
            });
        });
    }
    handleSizedClick();
    


    if(window.location.pathname.includes('products')){
        const checkRecommendations = setInterval(checkRecommendationsTimer, 300);
        function checkRecommendationsTimer() {
            if(document.querySelectorAll('product-recommendations .product-list product-card').length > 0){
                clearInterval(checkRecommendations);
                handleSizedClick();
            }
        }
        setTimeout(() => {
            clearInterval(checkRecommendations);
        }, 3000);
    }
});
